<template>
    <div class="components-view has-leaving-component">
        <main class="current-component">
            <div class="min-width-on-hide">
                <scroll-hide-nav>
                    <div class="max-w-content">
                        <tag-list :tags="tags" :active-tags="activeTags" @click="handleClick"></tag-list>
                    </div>
                    <pre-loader-component :visible="loading"></pre-loader-component>
                    <div v-show="!loading" class="faq-box">
                        <div class="max-w-content">
                            <div class="accordion">
                                <faq-item v-for="(item,index) in faq" :key="index" :item="item" @open="openItem(index)"
                                          :opened="current===index"></faq-item>
                            </div>
                        </div>
                        <ask-question></ask-question>
                    </div>
                </scroll-hide-nav>
            </div>
        </main>
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters, mapMutations} from 'vuex'
    import TagList from "../common/TagList";
    import PreLoaderComponent from "../common/PreLoader";
    import FaqItem from "./FaqItem";
    import AskQuestion from "./AskQuestion";
    import ScrollHideNav from "../common/ScrollHideNav";

    export default {
        name: 'faq-component-box',
        components: {
            ScrollHideNav,
            AskQuestion,
            FaqItem,
            PreLoaderComponent,
            TagList
        },
        data() {
            return {
                current: null,
                ops: {
                    vuescroll: {
                        pullRefresh: {
                            enable: true
                        },
                        pushLoad: {
                            enable: true,
                            auto: true,
                            autoLoadDistance: 10
                        }
                    },
                }
            }
        },
        computed: {
            ...mapState({
                loading: state => state.faq.loading,
                tags: state => state.faq.tags,
                activeTags: state => state.faq.activeTags,
                faq: state => state.faq.faq
            }),
            ...mapGetters('faq', [
                'getTagsIds'
            ]),
        },
        methods: {
            ...mapActions('faq', [
                'getFaq',
                'getAllTags'
            ]),
            ...mapMutations('faq', [
                'setActiveTag',
                'setAppClass',
                'setActiveTags'
            ]),
            ...mapMutations([
                'setAppClass'
            ]),
            handleClick(e) {
                this.getFaq();
                this.setActiveTag(e);
            },
            openItem(index) {
                this.current = this.current === index ? null : index
            }
        },
        created() {
            this.setAppClass('faq-component');
            this.getAllTags().then(() => {
                let tags = this.$route.query.tag;
                if (tags) {
                    tags = tags.map(Number);
                    this.setActiveTags(tags)
                }
                this.getFaq();
            });
        },
        destroyed() {
            this.setActiveTags([])
        }
    }
</script>


<style scoped>

</style>
